import type { DefaultTheme } from 'styled-components';

import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import type { CampaignListRouteParams } from './types.ts';

export const createCampaignTypeValidator =
  (allowedTypes: string | string[]): ParamsValidator<CampaignListRouteParams> =>
  ({ type }) => {
    const allowed = Array.isArray(allowedTypes) ? allowedTypes.includes(type) : allowedTypes === type;

    return allowed;
  };

export const getStatusColor = (status: string | undefined, theme: DefaultTheme): string | undefined => {
  if (status === 'green' || status === 'GREEN') {
    return theme.colors.positive100;
  }
  if (status === 'yellow' || status === 'YELLOW') {
    return theme.colors.warning100;
  }
  if (status === 'red' || status === 'RED') {
    return theme.colors.critical100;
  }
  return undefined;
};

export const getStatus = (color: string | undefined, theme: DefaultTheme): string => {
  if (color === 'red') {
    return theme.colors.critical100;
  }
  if (color === 'yellow') {
    return theme.colors.warning100;
  }
  return theme.colors.positive100;
};
